import React, { useEffect, useState } from 'react';
import { fetchScenarios, createScenario, deleteScenario, updateScenario, Scenario } from '../api';
import ScenarioBuilder from '../components/ScenarioBuilder';

const Scenarios: React.FC = () => {
  const [scenarios, setScenarios] = useState<Scenario[]>([]);
  const [editing, setEditing] = useState<Scenario | null>(null);
  const [creating, setCreating] = useState(false);

  const load = async () => {
    try {
      const list = await fetchScenarios();
      setScenarios(list);
    } catch (e) {
      alert('Не удалось загрузить сценарии');
    }
  };

  useEffect(() => {
    load();
  }, []);

  const handleCreate = async (name: string, config: any) => {
    try {
      await createScenario({ name, config });
      setCreating(false);
      load();
    } catch (e) {
      alert('Ошибка создания');
    }
  };

  const handleUpdate = async (name: string, config: any) => {
    if (!editing) return;
    try {
      await updateScenario(editing.id, { name, config });
      setEditing(null);
      load();
    } catch (e) {
      alert('Ошибка сохранения');
    }
  };

  const handleDelete = async (id: number) => {
    if (window.confirm('Удалить сценарий?')) {
      try {
        await deleteScenario(id);
        load();
      } catch (e) {
        alert('Ошибка удаления');
      }
    }
  };

  // Если открыт конструктор — показываем его на весь экран
  if (creating) {
    return (
      <ScenarioBuilder
        onSave={handleCreate}
        onCancel={() => setCreating(false)}
      />
    );
  }

  if (editing) {
    return (
      <ScenarioBuilder
        initialName={editing.name}
        initialConfig={editing.config}
        onSave={handleUpdate}
        onCancel={() => setEditing(null)}
      />
    );
  }

  // Основной список сценариев
  return (
    <div style={{
      minHeight: '100vh',
      background: '#f0f2f5',
      padding: 32,
      fontFamily: '"Inter", "Roboto", "Segoe UI", sans-serif',
    }}>
      <div style={{ maxWidth: 1000, margin: '0 auto' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
          <h2 style={{ margin: 0, fontSize: 24, fontWeight: 700, color: '#1a1a1a' }}>Сценарии</h2>
          <button
            onClick={() => setCreating(true)}
            style={{
              padding: '10px 20px',
              background: '#1677ff',
              color: 'white',
              border: 'none',
              borderRadius: 8,
              fontWeight: 600,
              fontSize: 14,
              cursor: 'pointer',
              boxShadow: '0 2px 6px rgba(22,119,255,0.3)',
            }}
          >
            + Создать сценарий
          </button>
        </div>

        {scenarios.length === 0 ? (
          <div style={{ textAlign: 'center', padding: 60, color: '#888' }}>
            Нет созданных сценариев. Нажмите «Создать сценарий», чтобы начать.
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            {scenarios.map(s => (
              <div
                key={s.id}
                style={{
                  background: 'white',
                  borderRadius: 12,
                  padding: '16px 20px',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  boxShadow: '0 1px 4px rgba(0,0,0,0.04)',
                  border: '1px solid #f0f0f0',
                }}
              >
                <div>
                  <strong style={{ fontSize: 16 }}>{s.name}</strong>
                  <span style={{
                    marginLeft: 12,
                    fontSize: 12,
                    padding: '2px 8px',
                    borderRadius: 12,
                    background: s.is_active ? '#e6fffb' : '#fff2e8',
                    color: s.is_active ? '#08979c' : '#d46b08',
                    fontWeight: 500,
                  }}>
                    {s.is_active ? 'Активен' : 'Неактивен'}
                  </span>
                </div>
                <div style={{ display: 'flex', gap: 8 }}>
                  <button
                    onClick={() => setEditing(s)}
                    style={{
                      padding: '6px 14px',
                      background: '#f5f5f5',
                      border: '1px solid #d9d9d9',
                      borderRadius: 6,
                      cursor: 'pointer',
                      fontSize: 13,
                    }}
                  >
                    ✏️
                  </button>
                  <button
                    onClick={() => handleDelete(s.id)}
                    style={{
                      padding: '6px 14px',
                      background: '#fff1f0',
                      border: '1px solid #ffa39e',
                      borderRadius: 6,
                      cursor: 'pointer',
                      fontSize: 13,
                      color: '#cf1322',
                    }}
                  >
                    🗑️
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Scenarios;